import { EVANGELHOS, type LeituraBiblia } from '../biblia';
import { NOVO_TESTAMENTO } from '../constantes';

// Prateleira dos Evangelhos: as 4 lombadas em pé; a do dia fica erguida e
// dourada. Abaixo, os dois números grandes (capítulo e versículos).
export default function PrateleiraBiblia({ leitura }: { leitura: LeituraBiblia }) {
  return (
    <div className="text-center">
      <p className="rotulo">{NOVO_TESTAMENTO}</p>

      <div className="mt-3 flex items-end justify-center gap-2">
        {EVANGELHOS.map((nome, i) => {
          const ordem = i + 1;
          const ativo = ordem === leitura.ordem;
          return (
            <div
              key={nome}
              className="flex h-[120px] w-9 items-center justify-center rounded-b-sm rounded-t-md border transition-transform"
              style={{
                transform: ativo ? 'translateY(-10px)' : undefined,
                background: ativo
                  ? 'linear-gradient(180deg,#E5C273,#CFA552)'
                  : 'rgba(255,255,255,.05)',
                borderColor: ativo ? 'transparent' : 'rgba(217,178,95,.35)',
                color: ativo ? 'var(--sobre-ouro)' : 'var(--texto-2)',
                boxShadow: ativo ? '0 12px 26px -8px rgba(217,178,95,.6)' : undefined,
              }}
            >
              <span className="rotate-180 text-[13px] font-semibold tracking-wide [writing-mode:vertical-rl]">
                {nome}
              </span>
            </div>
          );
        })}
      </div>

      <p className="mt-4 text-[15px] font-medium text-[color:var(--texto)]">
        Evangelho segundo São {leitura.livro}
      </p>
      <p className="mt-1 text-[13px] text-[color:var(--texto-2)]">
        {leitura.ordem}º livro do Novo Testamento
      </p>

      <div className="mt-6 flex items-start justify-center gap-8">
        <div>
          <p className="text-[13px] font-semibold text-[color:var(--texto-2)]">Capítulo</p>
          <p
            className="leitura"
            style={{ color: 'var(--ouro)', fontSize: 64, lineHeight: 1 }}
          >
            {leitura.capitulo}
          </p>
        </div>
        <div>
          <p className="text-[13px] font-semibold text-[color:var(--texto-2)]">Versículos</p>
          <p className="leitura" style={{ color: 'var(--ouro)', fontSize: 34, lineHeight: 1.1 }}>
            {leitura.versiculos}
          </p>
        </div>
      </div>
    </div>
  );
}